// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "15d68419e831fca67d195f168ef09a7032b9fdc6/static/css/" + chunkId + "." + "8ea9c403" + ".chunk.css";
};